// src/components/common/PaymentHistoryList/PaymentHistoryList.jsx
// Read-only payment records list — same look as OrderDetailsPage's Payment Records card
// (method icon, green amount, reference, date), shared by procurement pages.
import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar } from 'lucide-react';
import { useLocalization } from '../../../contexts/LocalizationContext';
import { PaymentMethodIcon } from '../../../utils/paymentMethodIcons';
import { formatCurrency } from '../../../utils/orderCalculations';
import { formatDate } from '../../../utils/dateUtils';
import styles from './PaymentHistoryList.module.css';

const PaymentHistoryList = ({ payments = [] }) => {
  const { t } = useLocalization();

  return (
    <div className={styles.paymentList}>
      {payments.map((payment) => (
        <div key={payment.id} className={styles.paymentRecord}>
          <div className={styles.paymentHeader}>
            <PaymentMethodIcon
              iconFileName={payment.iconFileName}
              label={payment.label}
              className={styles.paymentMethod}
            />
            <span className={styles.paymentAmount}>{formatCurrency(payment.amount)}</span>
          </div>
          {payment.badge && (
            payment.badgeTo ? (
              <Link to={payment.badgeTo} className={styles.paymentBadge}>{payment.badge}</Link>
            ) : (
              <span className={styles.paymentBadge}>{payment.badge}</span>
            )
          )}
          {payment.reference && (
            <div className={styles.paymentReference}>
              {t('common.ref')}:{' '}
              {payment.referenceTo
                ? <Link to={payment.referenceTo} className={styles.paymentReferenceLink}>{payment.reference}</Link>
                : payment.reference}
            </div>
          )}
          <div className={styles.paymentDate}>
            <Calendar size={12} />
            {formatDate(payment.date)}
          </div>
        </div>
      ))}
    </div>
  );
};

export default PaymentHistoryList;
